import { API } from "./api";
import { getSession } from "./authUtils";
import axios from "axios";

export const networkRequest = function (
  endpoint: string,
  httpMethod: string,
  params?: any,
  body?: any,
  signal?: any
) {
  let url = API.FAST_API.URL + endpoint;
  if (params) {
    let count = 0;
    for (const key in params) {
      if (!Array.isArray(params[key])) {
        params[key] = [params[key]];
      }
      /*eslint-disable */
      params[key].forEach((e: any) => {
        if (count === 0) {
          url += `?${key}=${encodeURIComponent(e)}`;
        } else {
          url += `&${key}=${encodeURIComponent(e)}`;
        }
        count++;
      });
    }
  }
  return fetch(url, {
    method: httpMethod,
    headers: {
      accept: "*/*",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "POST,GET,DELETE,PUT,PATCH",
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/json",
      Authorization: `bearer ${API.FAST_API.TOKEN}`,
    },
    body: body ? JSON.stringify(body) : undefined,
    signal: signal,
  })
    .then((response) => {
      if (response.ok) return response;
      throw response;
    })
    .catch((eResponse) =>
      eResponse.json().then((data: any) => {
        throw data;
      })
    );
};

export const networkGraphqlRequest = function (
  graphqlMethod?: any,
  client?: any,
  queryString?: any,
  variables?: any,
  networkOnly?: any
) {
  return getSession()
    .then(({ accessToken }: any) => {
      const token = accessToken.jwtToken;
      localStorage.setItem("accessToken", token);
      if (graphqlMethod === "QUERY") {
        return client
          .query({
            query: queryString,
            variables: variables,
            fetchPolicy: networkOnly ? "network-only" : "cache-first",
          })
          .then(({ errors, data }) => {
            if (errors) throw errors;
            return data;
          })
          .catch((errors: any) => {
            throw errors; // TODO: Review this later
          });
      } else {
        return client
          .mutate({
            mutation: queryString,
            variables: variables,
          })
          .then(({ errors, data }) => {
            if (errors) throw errors;
            return data;
          })
          .catch((errors: any) => {
            throw errors; // TODO: Review this later
          });
      }
    })
    .catch((err) => {
      if (err && typeof err == "object" && err.code === 403) {
        sessionStorage.setItem("sessionExpired", true.toString());
        window.location.reload();
      } else throw err;
    });
};

export const networkBackendRequest = function (
  endpoint: any,
  httpMethod: any,
  params?: any,
  body?: any,
  signal?: any,
  requestByAxios?: boolean
) {
  if (!params) params = {};
  return getSession()
    .then(({ accessToken }: any) => {
      const token = accessToken.jwtToken;
      localStorage.setItem("accessToken", token);

      let url = API.BACKEND.URL + "/api" + endpoint;
      if (params) {
        let count = 0;
        for (const key in params) {
          if (!Array.isArray(params[key])) {
            params[key] = [params[key]];
          }
          /*eslint-disable */
          params[key].forEach((e: any) => {
            if (count === 0) {
              url += `?${key}=${encodeURIComponent(e)}`;
            } else {
              url += `&${key}=${encodeURIComponent(e)}`;
            }
            count++;
          });
        }
      }

      return requestByAxios
        ? axios
            .request({
              url,
              method: httpMethod,
              headers: {
                accept: "*/*",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "POST,GET,DELETE,PUT,PATCH",
                "X-Requested-With": "XMLHttpRequest",
                "Content-Type": "application/json",
                Authorization: `bearer ${token}`,
              },
              data: body,
              signal,
            })
            .then((x) => x.data)
            .catch((e) => {
              throw e.response.data;
            })
        : fetch(url, {
            method: httpMethod,
            headers: {
              accept: "*/*",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "POST,GET,DELETE,PUT,PATCH",
              "X-Requested-With": "XMLHttpRequest",
              "Content-Type": "application/json",
              Authorization: `bearer ${token}`,
            },
            body: JSON.stringify(body),
            signal: signal,
          })
            .then((response) => {
              if (response.ok) return response;
              throw response;
            })
            .catch((eResponse) => {
              if (eResponse.name === "AbortError") throw eResponse;
              // TODO: The server may return an error object,
              // and is converted using .json. Review this later
              return eResponse.json().then((data: any) => {
                const error = { ...data, status: eResponse.status };
                throw error;
              });
            });
    })
    .catch((err) => {
      if (err && typeof err == "object" && err.code === 403) {
        sessionStorage.setItem("sessionExpired", true.toString());
        window.location.reload();
      } else throw err;
    });
};

export function networkUploadRequest(
  endpoint: string,
  httpMethod: string,
  params?: any,
  body?: any
) {
  let url = endpoint;
  if (params) {
    let count = 0;
    for (const key in params) {
      if (!Array.isArray(params[key])) {
        params[key] = [params[key]];
      }
      params[key].forEach((e) => {
        if (count === 0) {
          url += `?${key}=${encodeURIComponent(e)}`;
        } else {
          url += `&${key}=${encodeURIComponent(e)}`;
        }
        count++;
      });
    }
  }

  return fetch(url, {
    method: httpMethod,
    body: body,
  })
    .then((response) => {
      if (response.ok) return response;
      throw response;
    })
    .catch((eResponse) => {
      return eResponse; // TODO: Check error codes later.
    });
}

export function ChatbotSendToken() {
  const dfMessenger = document.querySelector("df-messenger");
  return getSession()
    .then(({ accessToken }: any) => {
      const token = accessToken.jwtToken;
      localStorage.setItem("accessToken", token);
      dfMessenger.setAttribute("user-id", token);
    })
    .catch((err) => {
      if (err && typeof err == "object" && err.code === 403) {
        sessionStorage.setItem("sessionExpired", true.toString());
        window.location.reload();
      } else throw err;
    });
}
